var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResendInvite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.602515 6.80796C0.177515 6.63713 0.182515 6.38296 0.630848 6.23379L16.5358 0.932127C16.9767 0.78546 17.2292 1.03213 17.1059 1.46379L12.5608 17.3688C12.4358 17.8096 12.165 17.8296 11.9633 17.4271L8.16668 9.83296L0.602515 6.80796ZM4.67752 6.64129L9.37418 8.52046L11.9075 13.5888L14.8625 3.24713L4.67668 6.64129H4.67752Z",
    fill: "#2E2E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResendInvite);
export default __webpack_public_path__ + "static/media/resendInvite.f6a92b00183b017624f814480d49c0b0.svg";
export { ForwardRef as ReactComponent };